// Dizionario inglese del CV Builder (landing + editor + stepper/wizard).
// Chiavi = stringhe italiane originali usate nei call site t('...').
// Il modulo si auto-registra su i18n.js: importarlo PRIMA degli altri moduli locali.
import { registerTranslations } from './i18n.js';

export const CV_BUILDER_EN = {
  // Modelli, tavolozze e colonne (galleria e pannello Personalizza).
  'Classico': 'Classic',
  'Terminale': 'Terminal',
  'Evidenza': 'Spotlight',
  'Giallo': 'Yellow',
  'Corallo': 'Coral',
  'Menta': 'Mint',
  'Azzurro': 'Sky',
  'Lavanda': 'Lavender',
  'Elegante': 'Elegant',
  'Avorio': 'Ivory',
  'Petrolio': 'Petrol',
  'Notte e ambra': 'Night and amber',
  'Bosco': 'Forest',
  'Prugna': 'Plum',
  'Grafite': 'Graphite',
  'Orbite': 'Orbits',
  'Smeraldo': 'Emerald',
  'Ghiaccio': 'Ice',
  'Rame': 'Copper',
  'Glicine': 'Wisteria',
  'Carta': 'Paper',
  'Palette rapide': 'Quick palettes',
  'Tavolozza': 'Palette',
  'Classica': 'Classic',
  'Nero': 'Black',
  'Nero e grigio': 'Black and grey',
  'Notte': 'Night',
  'Giorno': 'Day',
  'Colonna larga': 'Wide column',
  'Colonna stretta': 'Narrow column',
  'Colonna di {sezione}': 'Column for {sezione}',
  'Colonne automatiche': 'Automatic columns',
  '"{name}" era stato eliminato da un altro dispositivo ed è stato rimosso.': '"{name}" was deleted from another device and has been removed.',
  '({count}/{limit} questo mese)': '({count}/{limit} this month)',
  '({n} modifiche)': '({n} changes)',
  '(vuoto)': '(empty)',
  '{n} campi non sono stati tradotti (testo troppo lungo o CV molto grande) e restano in lingua originale.': '{n} fields were not translated (text too long or CV too large) and remain in the original language.',
  '{n} da migliorare': '{n} to improve',
  '{n} prioritari': '{n} critical',
  '{name} · su misura': '{name} · tailored',
  '{name} · migliorato': '{name} · improved',
  '{name} copia': '{name} copy',
  '{plan} non attivo': '{plan} not active',
  'Abbiamo trovato una versione più recente di "{name}" su un altro dispositivo.': 'We found a more recent version of "{name}" on another device.',
  'Accesso gratuito non attivo': 'Free access not active',
  'Analisi completata!': 'Analysis complete!',
  'Nessuna lingua trovata.': 'No language found.',
  'CV migliorato pronto!': 'Improved CV ready!',
  'Cerchiamo dove il CV può dire di più di te': 'We look for where your CV could say more about you',
  'Errore durante l\'analisi del coach.': 'Error during the coach analysis.',
  'Errore durante la riscrittura. Riprova.': 'Error while rewriting. Please try again.',
  'Rafforziamo bullet, profilo e risultati con i tuoi dati': 'We strengthen bullets, summary and results with your data',
  'Ricerca dei punti deboli': 'Finding the weak spots',
  'Stiamo formulando le domande più utili per migliorarlo': 'We are preparing the most useful questions to improve it',
  'Stiamo leggendo le tue risposte': 'We are reading your answers',
  'Ultimi ritocchi per un CV più incisivo': 'Final touches for a sharper CV',
  'Accesso Lifetime': 'Lifetime access',
  'Account Premium': 'Premium account',
  'Adattiamo tagline, profilo e bullet points': 'Adapting your tagline, summary and bullet points',
  'Aggiorno anteprima...': 'Updating preview...',
  'Aggiungi almeno 1 esperienza': 'Add at least 1 experience',
  'Aggiungi almeno un numero': 'Add at least one number',
  'Aggiungi CV': 'Add CV',
  'Aggiungi elemento': 'Add item',
  'Aggiungi https://: non cambia il layout, ma garantisce un link corretto per recruiter e sistemi ATS.': "Add https://: it doesn't change the layout, but it guarantees a correct link for recruiters and ATS systems.",
  'Aggiungi il nome completo': 'Add your full name',
  'Aggiungi la formazione': 'Add your education',
  'Aggiungi logo': 'Add logo',
  'Aggiungi sezione': 'Add section',
  'AI non disponibile. Riprova tra poco.': 'AI unavailable. Try again shortly.',
  'Aiuto formattazione': 'Formatting help',
  'Bandiera': 'Flag',
  'Scegli bandiera': 'Choose flag',
  'Sezioni del CV': 'CV sections',
  'Strumenti': 'Tools',
  'Azioni': 'Actions',
  'Accedi': 'Log in',
  'Personalizza': 'Customise',
  'Invia feedback': 'Send feedback',
  'Nessuna bandiera': 'No flag',
  'Alcuni punti sono troppo lunghi': 'Some bullet points are too long',
  'Allinea al centro': 'Align middle',
  'Allinea in alto': 'Align top',
  'Allineamento immagine': 'Image alignment',
  'Allineamento keyword': 'Keyword alignment',
  'Allineamento logo': 'Logo alignment',
  'Analisi': 'Analysis',
  "Analisi dell'offerta": 'Analysing the job posting',
  'Analisi delle risposte': 'Analysing your answers',
  'Analisi delle sezioni': 'Analysing the sections',
  'Analizza': 'Analyse',
  'Anche un proxy basta: volumi, tempi, dimensione team, numero clienti, budget gestito.': 'Even a proxy works: volumes, timelines, team size, number of clients, budget managed.',
  'Annuale': 'Yearly',
  'Annulla': 'Cancel',
  'Annulla per continuare con questa versione (rischi di sovrascrivere quella più recente al prossimo salvataggio).': 'Cancel to keep working on this version (you may overwrite the newer one on the next save).',
  'Anteprima aggiornata ({zoom}%, {pages} pagine)': 'Preview updated ({zoom}%, {pages} pages)',
  'Anteprima CV': 'CV preview',
  'Applica': 'Apply',
  'Attendi {seconds}s': 'Wait {seconds}s',
  'Avanti': 'Next',
  'Avanzato': 'Advanced',
  'Azienda': 'Company',
  'azienda.com': 'company.com',
  'Base': 'Basic',
  'Basta anche solo il titolo più recente: per molti recruiter e ATS è un campo atteso.': 'Even just your latest degree is enough: many recruiters and ATS expect this field.',
  'Calendario': 'Calendar',
  'Cerchiamo le aree da approfondire': 'Looking for areas worth digging into',
  'Certificazioni, Corsi online, Workshop': 'Certifications, Online courses, Workshops',
  'Chiudi': 'Close',
  'Codice inviato. Controlla la posta.': 'Code sent. Check your inbox.',
  'Codice non valido o scaduto. Riprova.': 'Invalid or expired code. Try again.',
  'Collega le skill alle esperienze': 'Connect your skills to your experience',
  'Competenze': 'Skills',
  'Compila il CV e genera un suggerimento mirato quando vuoi.': 'Fill in your CV and generate a targeted tip whenever you like.',
  "Con {premiumLink} gestiamo tutto noi: incolli l'offerta, rispondi alle domande e approvi le modifiche. Nient'altro.": 'With {premiumLink} we handle everything: paste the job posting, answer the questions and approve the changes. Nothing else.',
  'Con il piano gratuito puoi avere al massimo {limit} CV. Passa a Premium per salvarne di più.': 'On the free plan you can have at most {limit} CVs. Upgrade to Premium to save more.',
  'Con il piano gratuito puoi modificare solo i primi {limit} CV. Sei stato spostato su "{name}".': 'On the free plan you can only edit the first {limit} CVs. You have been moved to "{name}".',
  'Configurazione non pronta. Riprova tra poco.': 'Configuration not ready. Try again shortly.',
  'Confrontiamo il tuo profilo con i requisiti richiesti': 'Comparing your profile with the requirements',
  'Continua': 'Continue',
  'Continua da dove avevi lasciato': 'Pick up where you left off',
  'controlla i punti sotto': 'check the items below',
  'Controlliamo che nomi, aziende e date restino invariati': 'Checking that names, companies and dates stay unchanged',
  "Copia il prompt qui sotto e incollalo in ChatGPT, Claude o Gemini. L'AI ti farà alcune domande: rispondi nella chat. Alla fine ti restituirà il CV riadattato in formato JSON. Copialo e incollalo qui sotto.": 'Copy the prompt below and paste it into ChatGPT, Claude or Gemini. The AI will ask you a few questions: answer in the chat. At the end it will return your tailored CV as JSON. Copy it and paste it below.',
  'Copia prompt': 'Copy prompt',
  'Copiato!': 'Copied!',
  'Corsivo': 'Italic',
  'Corsivo non disponibile per questo font': 'Italic not available for this font',
  'Crea un nuovo CV gratis': 'Create a new CV for free',
  'CV aggiornato con la versione più recente.': 'CV updated with the most recent version.',
  'CV bloccato': 'CV locked',
  'CV da PDF': 'CV from PDF',
  'CV importato': 'Imported CV',
  'CV importato!': 'CV imported!',
  'CV personalizzato pronto!': 'Tailored CV ready!',
  'CV principale': 'Main CV',
  'CV senza nome': 'Untitled CV',
  'CV svuotato. Puoi ricominciare da zero.': 'CV cleared. You can start from scratch.',
  'CV tradotto!': 'CV translated!',
  'Da migliorare': 'To improve',
  'Data di nascita': 'Date of birth',
  'Data fine': 'End date',
  'Data inizio': 'Start date',
  'Descrizione': 'Description',
  'Descrizione (opzionale)': 'Description (optional)',
  'Due righe di contesto sul ruolo, prima dei punti elenco': 'A couple of lines of context about the role, before the bullet points',
  'Due righe di contesto sul percorso, prima dei punti elenco': 'A couple of lines of context about the course, before the bullet points',
  'Descrizione livello': 'Level description',
  'Deve restare almeno un CV nel workspace.': 'At least one CV must remain in the workspace.',
  'Devi accettare i Termini e Condizioni per continuare.': 'You must accept the Terms and Conditions to continue.',
  "Devi effettuare l'accesso Premium.": 'You need to sign in with your Premium account.',
  'Devi essere Premium per usare questa funzione.': 'You need Premium to use this feature.',
  'Documento': 'Document',
  'Domande per personalizzare': 'Questions to tailor your CV',
  'Domande pronte!': 'Questions ready!',
  'Duplica': 'Duplicate',
  'Duplica CV': 'Duplicate CV',
  'Elementi: {count}': 'Items: {count}',
  'Elenco puntato': 'Bullet points',
  'Elimina': 'Delete',
  'Elimina CV': 'Delete CV',
  'Eliminare "{name}"? I dati locali di questo CV saranno rimossi dal workspace.': 'Delete "{name}"? The local data for this CV will be removed from the workspace.',
  'Errore': 'Error',
  'Errore di sincronizzazione': 'Sync error',
  "Errore durante l'analisi. Riprova.": 'Error during analysis. Try again.',
  'Errore durante la generazione.': 'Error during generation.',
  'Errore PDF': 'PDF error',
  'Errore sconosciuto': 'Unknown error',
  'Es.': 'E.g.',
  'es. 110 e lode': 'e.g. First-class honours',
  'es. certificazione, madrelingua': 'e.g. certification, native speaker',
  'Es. Portfolio': 'E.g. Portfolio',
  'es. Voto': 'e.g. Grade',
  'Esperienza': 'Experience',
  'Esperienza: aggiungi https:// al sito': 'Experience: add https:// to the website',
  'Esperienza: aggiungi punti mirati': 'Experience: add focused bullet points',
  'Estrazione delle informazioni': 'Extracting the information',
  'Fatto!': 'Done!',
  'Fine accesso': 'Access ends',
  'Fluente': 'Fluent',
  'Forma immagine': 'Image shape',
  'Forma logo': 'Logo shape',
  'Formazione': 'Education',
  'Genera prompt': 'Generate prompt',
  'Genera suggerimento ({remaining} rimanenti)': 'Generate tip ({remaining} left)',
  'Generazione': 'Generation',
  'Gestisci account Premium': 'Manage Premium account',
  'Gestisci Premium': 'Manage Premium',
  'GitHub: meglio URL completo': 'GitHub: use the full URL',
  'Grassetto': 'Bold',
  'Grazie per il tuo feedback!': 'Thanks for your feedback!',
  'Gruppi di tag con etichetta.': 'Groups of tags with a label.',
  'Gruppo': 'Group',
  'Hai raggiunto il limite di {limit} CV nel piano gratuito': 'You have reached the {limit}-CV limit on the free plan',
  'Hai raggiunto il limite di {limit} download PDF questo mese. Passa a Premium per download illimitati.': 'You have reached the limit of {limit} PDF downloads this month. Upgrade to Premium for unlimited downloads.',
  'Hai richiesto un codice da poco. Attendi qualche secondo e riprova.': 'You requested a code recently. Wait a few seconds and try again.',
  'Hai usato i {limit} suggerimenti gratuiti per questo CV. Passa a Premium per sbloccare gli altri {hidden}.': 'You have used the {limit} free tips for this CV. Upgrade to Premium to unlock the other {hidden}.',
  'Icona': 'Icon',
  'Identificazione dei gap': 'Identifying the gaps',
  'Identifichiamo le diverse aree del tuo CV': 'Identifying the different areas of your CV',
  'Il file selezionato non è un backup valido.': 'The selected file is not a valid backup.',
  'Il file selezionato non è un salvataggio valido.': 'The selected file is not a valid save file.',
  "Il JSON non sembra un CV. Assicurati che l'AI restituisca il CV personalizzato in formato JSON.": "The JSON doesn't look like a CV. Make sure the AI returns the tailored CV in JSON format.",
  'Il JSON sembra troncato o corrotto. Chiedi all\'AI di rigenerarlo, magari con il messaggio: "Rigenera solo il JSON, assicurati che sia completo e valido."': 'The JSON looks truncated or corrupted. Ask the AI to regenerate it, for example with: "Regenerate only the JSON, make sure it is complete and valid."',
  'Il messaggio deve contenere almeno 10 caratteri.': 'The message must be at least 10 characters long.',
  'Il messaggio è troppo lungo (max 2000 caratteri).': 'The message is too long (max 2000 characters).',
  "Il risultato dipende dal servizio che utilizzi e non possiamo garantirne la validità. Se riscontri problemi, valuta il {premiumLink} per un'esperienza guidata e affidabile.": 'The result depends on the service you use and we cannot guarantee its validity. If you run into problems, consider {premiumLink} for a guided, reliable experience.',
  'Il tuo CV è pronto per essere modificato': 'Your CV is ready to edit',
  'Immagine': 'Image',
  'Immagine con angoli arrotondati': 'Rounded-corner image',
  'Immagine quadrata': 'Square image',
  'Immagine tonda': 'Round image',
  'Immagine troppo grande (max 10MB).': 'Image too large (max 10MB).',
  'Immagine troppo grande (max 10MB). Scegli un file più piccolo.': 'Image too large (max 10MB). Choose a smaller file.',
  'Import fallito': 'Import failed',
  'Importa backup': 'Import backup',
  'Importa da PDF': 'Import from PDF',
  'Impossibile attivare la sincronizzazione cloud. Riprova.': 'Could not enable cloud sync. Try again.',
  'Impossibile avviare il pagamento. Riprova tra poco.': 'Could not start the payment. Try again shortly.',
  'Hai già un abbonamento Premium attivo con questa email. Accedi con il codice.': 'You already have an active Premium subscription with this email. Sign in with the code.',
  'Impossibile caricare l’immagine.': 'Could not load the image.',
  'Impossibile generare il feedback AI.': 'Could not generate the AI feedback.',
  'Impossibile generare il PDF. Riprova tra poco.': 'Could not generate the PDF. Try again shortly.',
  "Impossibile generare l'anteprima: {message}": 'Could not generate the preview: {message}',
  "Impossibile inviare il codice. Verifica l'email e riprova.": 'Could not send the code. Check the email address and try again.',
  'Impossibile leggere lo zip delle immagini.': 'Could not read the images zip.',
  'Impossibile leggere lo zip. Riprova.': 'Could not read the zip. Try again.',
  'Impossibile salvare il CV. Riprova.': 'Could not save the CV. Try again.',
  'Impossibile salvare il workspace. Riprova.': 'Could not save the workspace. Try again.',
  'Impossibile tradurre il CV. Riprova.': 'Could not translate the CV. Try again.',
  "Incolla la descrizione dell'offerta di lavoro. L'AI analizzerà il tuo CV e ti farà domande mirate per personalizzarlo al meglio.": 'Paste the job description. The AI will analyse your CV and ask you targeted questions to tailor it as well as possible.',
  "Incolla la risposta JSON dell'AI.": "Paste the AI's JSON response.",
  "Incolla qui la descrizione dell'offerta a cui vuoi candidarti...": 'Paste here the description of the job you want to apply for...',
  'Incolla qui la risposta che hai ricevuto...': 'Paste here the response you received...',
  "Incolla qui sotto la descrizione dell'offerta di lavoro a cui vuoi candidarti.": 'Paste below the description of the job you want to apply for.',
  'Indietro': 'Back',
  'Individuiamo i testi da tradurre nel tuo CV': 'Finding the texts to translate in your CV',
  'Inglese': 'English',
  "Inseriamo le parole chiave rilevanti dell'annuncio": 'Adding the relevant keywords from the posting',
  'Inserisci il codice a 6 cifre.': 'Enter the 6-digit code.',
  "Inserisci la descrizione dell'offerta.": 'Enter the job description.',
  'Inserisci un contatto rapido': 'Add a quick contact',
  'Inserisci un nome per la sezione.': 'Enter a name for the section.',
  'Inserisci un titolo.': 'Enter a title.',
  'Inserisci una email valida per continuare.': 'Enter a valid email to continue.',
  'Inserisci una email valida.': 'Enter a valid email.',
  'Intestazione': 'Header',
  'Trascina per riordinare': 'Drag to reorder',
  'Disclaimer legale': 'Legal disclaimer',
  'Interessi, Hobby, Tool preferiti': 'Interests, Hobbies, Favourite tools',
  'Intermedio': 'Intermediate',
  'Invia codice': 'Send code',
  'Invia risposte': 'Submit answers',
  'Istituto': 'Institution',
  'Italiano': 'Italian',
  "JSON non valido. Assicurati di incollare solo il JSON restituito dall'AI.": 'Invalid JSON. Make sure you paste only the JSON returned by the AI.',
  "L'AI sta traducendo il CV nella lingua scelta": 'The AI is translating your CV into the chosen language',
  'La descrizione è troppo lunga (max 15000 caratteri).': 'The description is too long (max 15000 characters).',
  'La richiesta ha impiegato troppo tempo. Riprova.': 'The request took too long. Try again.',
  'La richiesta ha impiegato troppo. Riprova.': 'The request took too long. Try again.',
  'La richiesta sta impiegando troppo tempo. Disattiva eventuali adblock/VPN e riprova.': 'The request is taking too long. Disable any adblock/VPN and try again.',
  'La tua risposta...': 'Your answer...',
  'Lavoro': 'Work',
  'Lettura dei contenuti': 'Reading the content',
  'Lettura del CV': 'Reading your CV',
  'Lettura del PDF': 'Reading the PDF',
  'Limite CV raggiunto': 'CV limit reached',
  'Limite di {limit} CV nel piano gratuito': '{limit}-CV limit on the free plan',
  'Limite di {limit} CV raggiunto nel piano gratuito.': '{limit}-CV limit reached on the free plan.',
  'Limite download raggiunto': 'Download limit reached',
  'Lingua': 'Language',
  'Nazionalità': 'Nationality',
  'Patente': 'Driving licence',
  'Lingue': 'Languages',
  'LinkedIn: meglio URL completo': 'LinkedIn: use the full URL',
  'Livello (1-5)': 'Level (1-5)',
  'Località': 'Location',
  'Logo con angoli arrotondati': 'Rounded-corner logo',
  'Logo quadrato': 'Square logo',
  'Logo tondo': 'Round logo',
  'Madrelingua': 'Native',
  'Mancano {n} immagini: carica lo zip esportato.': '{n} images are missing: upload the exported zip.',
  'Mancano ancora {n} immagini.': '{n} images are still missing.',
  'Mensile': 'Monthly',
  'Messaggio': 'Message',
  'Metti il Profilo in alto': 'Put the Summary at the top',
  'Mettiamo tutto in ordine nel formato giusto': 'Putting everything in order in the right format',
  'Modifica icona': 'Edit icon',
  'Modifiche applicate.': 'Changes applied.',
  'Molte skill elencate non compaiono mai nei testi: cita le più importanti dentro bullet o progetti, dove acquistano credibilità.': 'Many listed skills never appear in your texts: mention the most important ones in bullets or projects, where they gain credibility.',
  'Nascondi sezione': 'Hide section',
  'Nei bullet dell’esperienza: se superi 2 righe, spezza azione/risultato e contesto.': 'In your experience bullets: if you go over 2 lines, split action/result and context.',
  'Nessun abbonamento attivo': 'No active subscription',
  'Nessun contatto aggiunto.': 'No contacts added.',
  'Nessun file selezionato': 'No file selected',
  'Nessun gruppo aggiunto.': 'No groups added.',
  'Nessun progetto aggiunto.': 'No projects added.',
  'Nessun punto aggiunto.': 'No bullet points added.',
  'Nessun punto critico rilevato. Se vuoi, apri l’anteprima PDF e fai un ultimo giro di pulizia.': 'No critical issues found. If you like, open the PDF preview and do one last clean-up pass.',
  'Nessun suggerimento prioritario.': 'No priority suggestions.',
  'Nessun testo da tradurre.': 'No text to translate.',
  'Nessuna esperienza aggiunta.': 'No experience added.',
  'Nessuna formazione aggiunta.': 'No education added.',
  'Nessuna lingua aggiunta.': 'No languages added.',
  'Nessuna modifica proposta.': 'No changes proposed.',
  'Nessuna skill aggiunta.': 'No skills added.',
  'Nome del nuovo CV': 'Name of the new CV',
  'Nome progetto': 'Project name',
  'Nome, link, immagine, descrizione e punti elenco.': 'Name, link, image, description and bullet points.',
  'Non cambia il layout, ma garantisce che i link siano letti correttamente da recruiter e ATS.': "It doesn't change the layout, but it ensures links are read correctly by recruiters and ATS.",
  'Non cambia il layout, ma rende i link affidabili per recruiter e ATS.': "It doesn't change the layout, but it makes links reliable for recruiters and ATS.",
  'Non è stato possibile leggere il testo dal PDF. Prova con un PDF diverso.': 'Could not read the text from the PDF. Try a different PDF.',
  'Note': 'Notes',
  'Nuovo CV creato con le modifiche selezionate.': 'New CV created with the selected changes.',
  'Nuovo CV creato dal PDF.': 'New CV created from the PDF.',
  'Opzionale': 'Optional',
  'Ora: {length} caratteri. Punta a 250-450: ruolo, seniority, contesto e 1-2 risultati.': 'Now: {length} characters. Aim for 250-450: role, seniority, context and 1-2 results.',
  'Ora: {length} caratteri. Taglia il contorno: 3-5 righe, solo segnali forti e misurabili.': 'Now: {length} characters. Trim the filler: 3-5 lines, only strong, measurable signals.',
  'Ora: circa {count}. Meglio poche ma supportate da esempi nelle esperienze/progetti.': 'Now: about {count}. Better to have fewer, backed by examples in your experience/projects.',
  'Organizzazione dei dati': 'Organising the data',
  'Ottieni tutti i suggerimenti': 'Get all the tips',
  'Ottimizzazione finale': 'Final optimisation',
  'Parti da zero': 'Start from scratch',
  'Passa a Premium': 'Upgrade to Premium',
  'PDF generato con successo!': 'PDF generated successfully!',
  'Penna': 'Pen',
  "Per estrarre le informazioni dal tuo CV, il testo verrà inviato a Google (Gemini) per l'analisi. Nessun dato verrà memorizzato sui sistemi di Stipendee.": 'To extract the information from your CV, the text will be sent to Google (Gemini) for analysis. No data will be stored on Stipendee systems.',
  'Personalizzato (link)': 'Custom (link)',
  'Personalizzato (testo)': 'Custom (text)',
  'Più di {limit} CV con Premium': 'More than {limit} CVs with Premium',
  'Più punti iniziano con “{word}”: alterna i verbi d’azione per dare ritmo alla lettura.': 'Several bullets start with "{word}": vary your action verbs to give the reading some rhythm.',
  'Preferito': 'Favourite',
  'Premio': 'Award',
  'Premium attivo': 'Premium active',
  'Premium attivo fino alla scadenza': 'Premium active until expiry',
  'Premium lifetime attivo': 'Premium lifetime active',
  'Premium non attivo': 'Premium not active',
  'Preparazione domande': 'Preparing the questions',
  'Prima sincronizzazione...': 'First sync...',
  'Prioritario': 'Critical',
  'Profilo': 'Summary',
  'Progetti': 'Projects',
  'Progetti: aggiungi https:// ai link': 'Projects: add https:// to your links',
  'Progetto': 'Project',
  'Prova a partire dal verbo d’azione e chiudi con impatto o scala (utenti, tempo, budget).': 'Try starting with the action verb and close with impact or scale (users, time, budget).',
  'Pubblicazioni, Portfolio, Open source': 'Publications, Portfolio, Open source',
  'Punto': 'Bullet',
  'Puoi generare fino a {limit} suggerimenti gratuiti per questo CV ({remaining} rimanenti).': 'You can generate up to {limit} free tips for this CV ({remaining} left).',
  'Puoi inviare un nuovo feedback tra {time}.': 'You can send new feedback in {time}.',
  'Qualcosa è andato storto. Riprova.': 'Something went wrong. Try again.',
  'Quasi fatto': 'Almost done',
  'Questa email non risulta associata a Premium.': 'This email is not associated with Premium.',
  'Recuperiamo esperienze, competenze e formazione': 'Retrieving experience, skills and education',
  'Regola': 'Adjust',
  'Regola foto profilo': 'Adjust profile photo',
  'Regola immagine progetto': 'Adjust project image',
  'Regola logo': 'Adjust logo',
  'Rendi i punti più “dimostrabili”': 'Make your bullets more "provable"',
  'Ricomincia da zero': 'Start over',
  'Rimuovi campo': 'Remove field',
  'Rimuovi elemento': 'Remove item',
  'Rimuovi esperienza': 'Remove experience',
  'Rimuovi formazione': 'Remove education',
  'Rimuovi gruppo': 'Remove group',
  'Rimuovi immagine': 'Remove image',
  'Rimuovi lingua': 'Remove language',
  'Rimuovi logo': 'Remove logo',
  'Rimuovi progetto': 'Remove project',
  'Rimuovi sezione': 'Remove section',
  'Rinnovo': 'Renewal',
  'Rinomina': 'Rename',
  'Rinomina CV': 'Rename CV',
  'Ripristina {section}': 'Restore {section}',
  'Riprova': 'Try again',
  'Riscrittura contenuti': 'Rewriting the content',
  "Risposta dell'AI": "AI's response",
  'Ruolo': 'Role',
  'Ruolo, azienda, date, luogo, descrizione e punti elenco.': 'Role, company, dates, location, description and bullet points.',
  'Salva una copia con le modifiche selezionate': 'Save a copy with the selected changes',
  'Salvati in locale nel browser ({count}/{limit} CV nel piano gratuito).': 'Saved locally in your browser ({count}/{limit} CVs on the free plan).',
  "Salvati in locale nel browser. Puoi tenerne più di uno e passare da uno all'altro.": 'Saved locally in your browser. You can keep more than one and switch between them.',
  'Sblocca altri {hidden} suggerimenti (Premium)': 'Unlock {hidden} more tips (Premium)',
  'Scarica PDF': 'Download PDF',
  'Scegli file': 'Choose file',
  'Scegli un formato (YYYY o MM/YYYY) e usalo ovunque: rende il CV più “pulito” e leggibile.': 'Pick one format (YYYY or MM/YYYY) and use it everywhere: it makes the CV cleaner and easier to read.',
  'Se il Summary è presente, conviene che sia la prima sezione dopo i contatti.': "If you have a Summary, it's best placed as the first section after your contact details.",
  'Se non vuoi il telefono, almeno email o link LinkedIn completo.': "If you'd rather not share a phone number, at least add an email or full LinkedIn link.",
  'Se scrivi “proattivo” o “problem solver”, aggiungi subito un esempio o un numero che lo dimostra.': 'If you write "proactive" or "problem solver", immediately add an example or a number that proves it.',
  'Se sei junior, vanno bene stage, progetti universitari o freelance: conta il contesto e il contributo.': "If you're junior, internships, university projects or freelance work are fine: context and contribution are what matter.",
  'Seleziona campo': 'Select field',
  'Seleziona il testo e usa i bottoni a fianco per grassetto, corsivo o link.': 'Select the text and use the buttons on the side for bold, italic or links.',
  "Il simbolo dell'elenco (•, –, ›…) lo scegli nel tab Personalizza.": 'You choose the list symbol (•, –, ›…) in the Customise tab.',
  'Font e dimensioni dei testi li imposti nel tab Personalizza.': 'You set text fonts and sizes in the Customise tab.',
  'Seleziona il tipo di feedback.': 'Select the feedback type.',
  'Seleziona tutti': 'Select all',
  'Serve anche per dare credibilità al PDF e per il nome file.': 'It also gives the PDF credibility and is used for the file name.',
  'Servizio non disponibile.': 'Service unavailable.',
  'Servizio non disponibile. Riprova più tardi.': 'Service unavailable. Try again later.',
  'Sezione': 'Section',
  'Sezione personalizzata': 'Custom section',
  'Si disattiva il {date}': 'Ends on {date}',
  'Si è verificato un errore. Riprova più tardi.': 'An error occurred. Try again later.',
  'Si rinnova il {date}': 'Renews on {date}',
  'Sincronizzarla ora? Le modifiche fatte finora in questa sessione andranno perse.': 'Sync it now? The changes made so far in this session will be lost.',
  'Sincronizzato': 'Synced',
  'Sincronizzazione...': 'Syncing...',
  'Sito web': 'Website',
  'Sito: aggiungi https://': 'Website: add https://',
  'Sostituisci aggettivi con prove': 'Replace adjectives with proof',
  'Spiega i periodi di pausa': 'Explain the gaps',
  'Sposta giu': 'Move down',
  'Sposta su': 'Move up',
  'Stiamo analizzando il contenuto del tuo CV': 'Analysing the content of your CV',
  'Stiamo aprendo il tuo documento e leggendo il contenuto': 'Opening your document and reading the content',
  'Stiamo formulando le domande più utili per te': 'Preparing the most useful questions for you',
  'Stiamo leggendo le tue risposte e il contesto': 'Reading your answers and the context',
  'Suggerimenti in base a quello che hai compilato: {parts}.': 'Tips based on what you have filled in: {parts}.',
  'Suggerimento': 'Tip',
  'Suggerimento {n} di {limit}. Se lo risolvi, potrai generarne un altro.': 'Tip {n} of {limit}. Once you address it, you can generate another.',
  'Summary troppo corto': 'Summary too short',
  'Summary troppo lungo': 'Summary too long',
  'Tagline: chiarisci il target': 'Tagline: clarify your target',
  'Target: 3-5 punti. Parti dai risultati, poi tool e metodo.': 'Target: 3-5 bullets. Start with results, then tools and method.',
  'Telefono': 'Phone',
  'Testo da mostrare': 'Text to display',
  "Ti aiutiamo a usare servizi esterni come ChatGPT, Claude o Gemini per riscrivere il tuo CV su misura per un'offerta specifica. Dovrai copiare un prompt, rispondere a qualche domanda e incollare il risultato. Serve un minimo di dimestichezza e il risultato non è garantito.": 'We help you use external services like ChatGPT, Claude or Gemini to rewrite your CV tailored to a specific job posting. You will need to copy a prompt, answer a few questions and paste the result. It takes a bit of familiarity and the result is not guaranteed.',
  'Timeout richiesta. Riprova.': 'Request timeout. Try again.',
  'Titolo di studio': 'Degree',
  'Titolo sezione': 'Section title',
  'Titolo, istituto, date, luogo e punti elenco.': 'Degree, institution, dates, location and bullet points.',
  'Titolo: {title}': 'Title: {title}',
  'Titolo: predefinito': 'Title: default',
  'Tra due esperienze c’è un intervallo di oltre un anno: se è stato formazione, viaggio o famiglia, una riga che lo racconta evita domande al buio.': 'There is a gap of more than a year between two experiences: if it was education, travel or family, one line explaining it avoids blind questions.',
  'Traduzione': 'Translation',
  'Traduzione in corso': 'Translation in progress',
  'Trimestrale': 'Quarterly',
  'Troppe richieste. Riprova tra qualche minuto.': 'Too many requests. Try again in a few minutes.',
  'Troppe skill: scegli le più rilevanti': 'Too many skills: pick the most relevant',
  'Ultimi ritocchi per un CV su misura': 'Final touches for a tailored CV',
  'Ultimi ritocchi prima di mostrarti il risultato': 'Final touches before showing you the result',
  'Un CV è stato aggiornato su un altro dispositivo: caricata la versione più recente.': 'A CV was updated on another device: the most recent version was loaded.',
  'Un indirizzo tipo nome.cognome è più professionale di uno con molte cifre: se ne hai uno, usalo nel CV.': 'An address like first.last looks more professional than one with lots of digits: if you have one, use it in your CV.',
  'Una riga: ruolo + specializzazione + valore. Aiuta a capire subito per cosa ti candidi.': 'One line: role + specialisation + value. It makes it immediately clear what you are applying for.',
  'Uniforma il formato date': 'Make date formats consistent',
  'URL sito azienda': 'Company website URL',
  'Usa https://github.com/...: non cambia il layout, ma rende il link più robusto per recruiter e ATS.': "Use https://github.com/...: it doesn't change the layout, but it makes the link more robust for recruiters and ATS.",
  'Usa https://linkedin.com/in/...: non cambia il layout, ma evita ambiguità e aiuta recruiter e ATS a riconoscere correttamente il profilo.': "Use https://linkedin.com/in/...: it doesn't change the layout, but it avoids ambiguity and helps recruiters and ATS recognise your profile correctly.",
  'Vai al campo': 'Go to field',
  'Vai allo screenshot {n}': 'Go to screenshot {n}',
  'Valore': 'Value',
  'Valuta un indirizzo email più sobrio': 'Consider a more professional email address',
  'Varia l’attacco dei punti': 'Vary how your bullets start',
  'Verifica finale': 'Final check',
  'Verifica pagamento fallita. Riprova o contattaci.': 'Payment verification failed. Try again or contact us.',
  'Verrà creato un <strong>nuovo CV</strong> nel workspace, senza sostituire quelli già presenti.': 'A <strong>new CV</strong> will be created in your workspace, without replacing the existing ones.',
  'Volontariato, Freelance, Consulenze': 'Volunteering, Freelance, Consulting',
  'Votazione (nome)': 'Grade (label)',
  'Votazione (valore)': 'Grade (value)',
  'Workspace esportato!': 'Workspace exported!',
  'Workspace importato.': 'Workspace imported.'
};

registerTranslations(CV_BUILDER_EN);
